import { IndicatorDTOHack } from '@atlassiansox/phobos-client-ts';

export type SLOIndicatorWithGroupType = IndicatorDTOHack & {
  groupType?: string;
  geo?: string;
  region?: string;
  shard?: string;
  db?: string;
};

// This used to be imported from phobos-client-ts but was removed in the latest version
export enum CohortMemberCohortTypeEnum {
  Global = 'GLOBAL',
  Geo = 'GEO',
  Region = 'REGION',
  Shard = 'SHARD',
  Db = 'DB',
}
